import React from 'react';
import PropTypes from 'prop-types';

import { ColumnsContent } from './ColumnsContent';
import { TableContent } from './TableContent';
import 'rc-dropdown/assets/index.css';

const MainPageContent = ({ stock, search, isTable, status, item, itemQueryParam }) => {
  return isTable ? (
    <TableContent stock={stock} search={search} status={status} item={item} itemQueryParam={itemQueryParam} />
  ) : (
    <ColumnsContent stock={stock} search={search} itemSearch={item} itemQueryParam={itemQueryParam} />
  );
};

MainPageContent.propTypes = {
  stock: PropTypes.any,
  isTable: PropTypes.bool,
  item: PropTypes.object,
  itemQueryParam: PropTypes.string,
  search: PropTypes.shape({
    item: PropTypes.string,
    string: PropTypes.string,
  }),
  status: PropTypes.string,
};

MainPageContent.defaultProps = {
  stock: null,
  search: {
    string: '',
    item: null,
  },
};

export { MainPageContent };
